export enum StorageType {
  Unknown,
  Session,
  Local,
}
